import { Nullable } from '@common/typescript/objects/Nullable';
import { WithId } from '@common/typescript/objects/WithId';

export interface Dictionary<T> {
	[key: string]: T;
}

export interface NumberKeyedDictionary<T> {
	[key: number]: T;
}

export enum Mode {
	View,
	Edit
}

export type StringBoolNumber = string | boolean | number;

/**
 * filter value change object
 * @interface HandleChangeEventElement
 */
export interface HandleChangeEventElement {
	currentTarget: {
		name: string;
		value: Nullable<StringBoolNumber | Array<StringBoolNumber>>;
	};
}

export type EqualPredicateDelegate<T> = (a: T, b: T) => boolean;

export const defaultEqualPredicate = <T extends WithId>(a: T, b: T) => a.id === b.id;
